import React, { useState } from "react";
import { Card, Switch, Button, notification, Typography, Spin } from "antd";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import ajaxService from "../../../services/ajax-service";

const { Title, Text } = Typography;

const GlobalTestAds = () => {
  const [loading, setLoading] = useState(false);
  const [useTestAds, setUseTestAds] = useState(false);

  const handleUpdate = async () => {
    setLoading(true);
    try {
      const res = await ajaxService.post("/admin/users/test-ads/global", {
        use_test_ads: useTestAds ? 1 : 0,
      });

      if (res.success) {
        notification.open({
          message: "Global test ads setting updated successfully",
          icon: <CheckCircleOutlined style={{ color: "#52c41a" }} />,
        });
      } else {
        throw new Error(res.message || "Failed to update");
      }
    } catch (e) {
      notification.open({
        message: e.message || "Unable to update global test ads setting",
        icon: <CloseCircleOutlined style={{ color: "#ff4d4f" }} />,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-container" style={{ padding: "24px" }}>
      <div className="module-header" style={{ marginBottom: "24px" }}>
        <Title level={2} className="module-title" style={{ margin: 0 }}>
          Global Test Ads Setting
        </Title>
        <Text type="secondary" className="module-subtitle">
          Manage the test ads status for all users globally.
        </Text>
      </div>

      <Card
        style={{
          maxWidth: 600,
          boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
          borderRadius: 8,
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
          <div>
            <Title level={5}>Enable Test Ads for all Users</Title>
            <Text type="secondary">
              Turning this on will override test ads settings for everyone. 
            </Text>
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <Text strong style={{ fontSize: "16px" }}>
              Test Ads:
            </Text>
            <Switch
              checked={useTestAds}
              onChange={(checked) => setUseTestAds(checked)}
              checkedChildren="ON"
              unCheckedChildren="OFF"
            />
          </div>

          <Button
            type="primary"
            onClick={handleUpdate}
            loading={loading}
            style={{ width: "120px", marginTop: "12px" }}
          >
            Save Setting
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default GlobalTestAds;
